module.exports = __webpack_public_path__ + "img/ilawyer_logo_white.077cecba.svg";